import { render, staticRenderFns } from "./unitDenominators.vue?vue&type=template&id=205a813c&scoped=true"
import script from "./unitDenominators.vue?vue&type=script&lang=js"
export * from "./unitDenominators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205a813c",
  null
  
)

export default component.exports